// extracted by mini-css-extract-plugin
export var footer = "_r3-0";
export var inherit = "_r3-1";
export var input = "_r3-2";
export var modalContent = "_r3-3";
export var quillEditor = "_r3-4";
export var subtitle = "_r3-5";